<template>
    <div class="helper-controls" :class="{ 'helper-home': $route.meta.route == 'Home' }">
        <template v-if="visible">
            <div>
                <wx-helper />
                <project-route
                    :to="{ name: 'BioVariantResult', query: { mode: 'codon' }, params: { id: $route.params.id } }"
                    target="_blank"
                    class="helper-control"
                    v-if="variant">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon1.png" class="helper-icon" />
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon1-active.png" class="helper-icon helper-icon-active" />
                    <div class="helper-context">{{ $t("MutationViewer") }}</div>
                </project-route>
                <project-route
                    :to="{ name: 'BioSequenceResult', query: { mode: 'cDNA' }, params: { id: $route.params.id } }"
                    target="_blank"
                    class="helper-control"
                    v-if="sequence">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon2.png" class="helper-icon" />
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon2-active.png" class="helper-icon helper-icon-active" />
                    <div class="helper-context">{{ $t("SequenceViewer", 2) }}</div>
                </project-route>
                <Comparison />
                <project-route :to="{ name: 'Chatagent' }" target="_blank" class="helper-control">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon4.png" class="helper-icon" />
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon4.png" class="helper-icon helper-icon-active" />
                    <div class="helper-context">{{ $t("AnsweringAssistant") }}</div>
                </project-route>
                <project-route :to="{ name: 'Videos' }" target="_blank" class="helper-control">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon7.png" class="helper-icon" />
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon7.png" class="helper-icon helper-icon-active" />
                    <div class="helper-context">{{ $t("Tutorials") }}</div>
                </project-route>
                <div class="helper-control" @click="triggerReturnTop">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon5.png" class="helper-icon" />
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon5.png" class="helper-icon helper-icon-active" />
                    <div class="helper-context">{{ $t("ReturnTop") }}</div>
                </div>
            </div>
            <div class="helper-colose" @click="visible = false"><ui-icon name="close2" /></div>
        </template>
        <div v-else>
            <div class="helper-control" @click="visible = true">
                <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon-more.png" class="helper-icon" />
                <img src="https://rdgta.cdn.cyagen.com/rddc/images/controls/icon-more.png" class="helper-icon helper-icon-active" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 私有组件
import Comparison from "./components/comparison/index.vue";
import WxHelper from "./components/wx/index.vue";
//* 路由
const route = useRoute();

//* 组件属性
const define = defineProps({ isTop: { type: Boolean, default: false } });
const emit = defineEmits(["returnTop"]);

//* 响应式变量
const variant = ref<boolean>(false);
const sequence = ref<boolean>(false);
const visible = ref<boolean>(true);

//* 回到顶部
const triggerReturnTop = () => {
    if (define.isTop) {
        emit("returnTop");
    } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
};

//* 页面数据初始化
if (route.meta.route == "Gene" && route.params.id) {
    const data = await api.server("GeneDetails", "/api/gene", {
        data: { id: route.params.id },
        method: "POST",
    });
    variant.value = data.value.species == "9606";
    sequence.value = true;
}
</script>

<style lang="less" scoped>
@import url("./style/index.less");
</style>
